import React, { useEffect, useState } from "react";
import { checkAppUpdate } from "../config/appUpdate";
import { IS_MOBILE_APP } from "../config/appVariant";

const wrap = { minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:24, background:"#f5f7f6", fontFamily:"Arial, sans-serif" };
const card = { width:"100%", maxWidth:420, background:"#fff", borderRadius:18, padding:28, boxShadow:"0 10px 30px rgba(0,0,0,.10)", textAlign:"center" };
const button = { width:"100%", border:0, borderRadius:10, padding:"13px 18px", fontSize:16, fontWeight:700, cursor:"pointer", background:"#003d32", color:"#fff" };

export default function AppUpdateGate({ children }) {
  const [state, setState] = useState(IS_MOBILE_APP ? "checking" : "ready");
  const [update, setUpdate] = useState(null);

  useEffect(() => {
    if (!IS_MOBILE_APP) return;
    let alive = true;
    checkAppUpdate()
      .then((result) => {
        if (!alive) return;
        if (result.required) { setUpdate(result); setState("required"); }
        else setState("ready");
      })
      // Fail open on temporary network/version-service failure. Login/API still needs network.
      .catch(() => alive && setState("ready"));
    return () => { alive = false; };
  }, []);

  if (state === "checking") {
    return <div style={wrap}><div style={card}><h2 style={{marginTop:0}}>MFSetu</h2><p>Checking app version…</p></div></div>;
  }

  if (state === "required") {
    const goToStore = () => {
      if (update?.storeUrl) window.location.assign(update.storeUrl);
    };
    return (
      <div style={wrap}>
        <div style={card}>
          <h2 style={{marginTop:0}}>Update Required</h2>
          <p style={{lineHeight:1.55}}>{update?.message}</p>
          <button type="button" style={button} onClick={goToStore} disabled={!update?.storeUrl}>Update Now</button>
          {!update?.storeUrl && <p style={{fontSize:13, marginBottom:0}}>Store link is temporarily unavailable.</p>}
        </div>
      </div>
    );
  }

  return children;
}
